import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Card from 'components/Card/Card';
import EmptyContent from 'components/EmptyContent/EmptyContent';
import Preloader from 'components/Preloader';
import CustomTable from 'components/CustomTable/CustomTable';
import { DEFAULT_PAGE_SIZE, proposalOverviewColumns } from './constants';
import useProposalOverview from './useProposalOverview';

const ProposalOverview = () => {
    const {t} = useTranslation();
    const {
            list,
            totalPages,
            page,
            setPage,
            isLoading,
            error,
        } = useProposalOverview();
    
        const tableColumns = proposalOverviewColumns(t);
    
        const onChangePage = useCallback((paging) => {
            setPage(paging);
        }, []);

    return (
        <Card title={t('clientDashboard.proposals.card.title')}>
            <Preloader isLoading={isLoading} error={error}>
                <EmptyContent data={list} text="Not Found">
                    <CustomTable
                        columns={tableColumns}
                        data={list}
                        onChange={onChangePage}
                        paging={{
                            pageSize: DEFAULT_PAGE_SIZE,
                            pageNumber: page,
                            totalPages,
                        }}
                    />
                </EmptyContent>
            </Preloader>
        </Card>
    );
};

export default ProposalOverview;
